<template>
  <div
    id="indexlayout-left"
    :class="{ narrow: isCollapse }"
    :style="{ background: menuBg }"
  >
    <div class="indexlayout-left-logo" v-if="siteSidebarLogo">
      <router-link to="/" class="logo-url">
        <div class="logo-container">
          <img alt="logo" :src="logo.img" height="30" />
          <h3
            v-if="!isCollapse"
            class="logo-title"
            :style="{ color: textColor }"
          >
            {{ logo.name }}
          </h3>
        </div>
        <!-- <img v-else alt="logo" :src="logo.img" width="30" /> -->
      </router-link>
    </div>
    <div class="indexlayout-left-menu">
      <el-scrollbar class="flex-scrollbar" wrap-class="default-scrollbar__wrap">
        <el-menu
          :default-active="getSidebarMenuActive"
          :collapse="isCollapse"
          :collapse-transition="false"
          :background-color="menuBg"
          :text-color="textColor"
        >
          <template v-if="!siteTopNavEnable">
            <!-- <div v-for="route in menus" :key="route.path">
              <div v-if="!route.hidden">
                {{ route.meta ? route.meta.title : 'test' }}
              </div>
            </div> -->
            <template v-if="!siteTopNavEnable">
              <sidebar-menu-item
                v-for="route in menus"
                :key="route.path"
                :routes="route"
                :base-path="route.path"
                :resolve-path="route.path"
                :active-top-menu="getTopMenuActive"
              />
            </template>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import SidebarMenuItem from '@/layout/components/SidebarMenuItem'
import {
  getBelongTopMenuPath,
  getActiveSidebarMenuPath
} from '@/utlis/permission'
import path from 'path'

export default {
  name: 'LayoutIndexLeft',
  components: {
    SidebarMenuItem
  },
  data() {
    return {}
  },
  computed: {
    menuBg() {
      return this.$store.state.theme.menuBg
    },
    textColor() {
      return this.$store.state.theme.color
    },
    isCollapse() {
      return !this.sidebarOpened
    },
    getSidebarMenuActive: function() {
      const route = this.$route
      return getActiveSidebarMenuPath(route)
    },
    getTopMenuActive() {
      let route = this.$route
      return getBelongTopMenuPath(route)
    },
    logo() {
      const { name, img } = this.$store.getters.logo
      return { name, img: require(`@/assets/images/${img}`) }
    },
    menus() {
      const rou = this.permission_routes.find(o => o.path === '/tele')
      const titles = {
        TeleDashboard: '诱杀预警',
        images: '远程监测',
        TeleReports: '数据分析'
      }
      const home = this.permission_routes.find(o => o.path === '/')

      return [home].concat(
        rou.children.map(r => {
          let title = titles[r.name]
          return title
            ? {
                ...r,
                meta: { ...r.meta, title },
                path: path.join(rou.path, r.path)
              }
            : { ...r, path: path.join(rou.path, r.path) }
        })
      )
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/variables.scss';
#indexlayout-left {
  display: flex;
  flex-direction: column;
  width: $leftSideBarWidth;
  height: 100vh;
  // background-color: $leftBgColor;
  color: $topMenuFontColor;
  transition-duration: 0.1s;
  .indexlayout-left-logo {
    width: 100%;
    height: $headerHeight;
    line-height: $headerHeight;
    text-align: center;
    vertical-align: middle;
    /* background-color: $subMenuBg; */
    .logo-url {
      display: inline-block;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .logo-title {
        display: inline-block;
        margin: 0;
        margin-left: 1rem;
        font-size: 16px;
        font-family: Roboto, sans-serif;
        color: $topMenuFontColor;
      }
    }
    .logo-container {
      text-align: left;
    }
    img {
      vertical-align: middle;
      margin-left: 12px;
      transition: margin 0.1s ease;
      &:not(:last-child) {
        margin-left: 20px;
      }
    }
  }
  .indexlayout-left-menu {
    flex: 1;
    display: flex;
    overflow: auto;
    // height: calc(100vh);
    /* .el-scrollbar {
        flex:1;
    } */
  }

  &.narrow {
    width: $leftSideBarMinWidth;
  }
}
</style>
